import { PAGE_TYPE } from '@/app/common/pageType.ts';

export const NAVIGATION_STEPS: PAGE_TYPE[] = [PAGE_TYPE.HOTEL_DETAIL, PAGE_TYPE.TRANSPORT_DETAIL, PAGE_TYPE.REVIEW];
